import {Message} from "types/Message";
import {dateTime, duration} from "services/date";
import {RRule} from "rrule";

/**
 * Transform the given message by deserializing object properties
 *
 * @internal
 * @param message
 */
export default function deserializeMessage(message: any): Message {
    message.cooldown = duration(message.cooldown)
    message.recurrence = message.recurrence ? RRule.fromString(message.recurrence) : null
    message.due_at = dateTime(message.due_at)
    message.last_sent_at = dateTime(message.last_sent_at)
    message.created_at = dateTime(message.created_at)
    message.updated_at = dateTime(message.updated_at)

    return message;
}